import { animated } from '@react-spring/web';
import { useTheme } from '@shopify/polaris-viz-core';
import style from './Crosshair.scss.js';
import { jsx } from 'react/jsx-runtime';

function Crosshair({
  x,
  height,
  opacity = 1,
  theme,
  id
}) {
  const selectedTheme = useTheme(theme);
  return /*#__PURE__*/jsx(animated.rect, {
    className: style.Crosshair,
    x: x,
    width: selectedTheme.crossHair.width,
    height: height,
    stroke: "none",
    id: id,
    style: {
      opacity,
      fill: selectedTheme.crossHair.color
    }
  });
}

export { Crosshair };
